// @ts-ignore
// asynchronous start boundary for webpack dynamic module loading
Promise.all([
    import('@jutro/config'),
    import('./config/config.json'),
    import('./startApp'),
    import('./utils/loadAdobeLaunch'),
]).then(
    ([{ setConfiguration }, appConfig, { startApp }, { loadAdobeLaunch }]) => {
        // set envConfig for the code executed before the Jutro React app starts
        setConfiguration({ ...appConfig, ...appConfig.env });

        loadAdobeLaunch(appConfig?.env?.ADOBE_LAUNCH_URL);

        startApp();
    }
);
